import styled, { css } from 'styled-components'
import { MentionsInput } from 'react-mentions'

interface WrapperProps {
	$isError?: boolean
	$isSuccess?: boolean
	$fullWidth?: boolean
	$transparentInput?: boolean
	$hideBorder?: boolean
}

const controlCss = css<WrapperProps>`
	border: ${({ $hideBorder }) => ($hideBorder ? 'none' : '1px solid #848898')};
	border-radius: 0.5rem;
	box-shadow: ${({ $hideBorder }) =>
		$hideBorder ? 'none' : '0px 1px 3px 0px rgba(132, 136, 152, 0.15)'};
	background-color: ${({ theme, $hideBorder }) =>
		$hideBorder ? 'transparent' : theme.pallette.geniiWhite};
	padding: 0.75rem;
	font-size: 0.875rem;

	${({ $hideBorder }) =>
		$hideBorder &&
		`
			border: none !important;
			box-shadow: none !important;
			background: transparent !important;
		`}

	${({ $transparentInput }) =>
		$transparentInput &&
		`
			background: transparent !important;
			border: none !important;
			box-shadow: none !important;
		`}

	${({ $fullWidth }) => ($fullWidth ? 'width: 100%;' : '')}

	${({ theme, $isSuccess }) =>
		$isSuccess &&
		`
			border-color: ${theme.pallette.success.main} !important;
		`}

	${({ theme, $isError }) =>
		$isError &&
		`
			border-color: ${theme.pallette.error.main} !important;
		`}
`

export const MentionsRoot = styled.div<WrapperProps>`
	${controlCss}
	position: relative;
`

export const StyledMentionsInput = styled(MentionsInput)`
  & .mentions__control {
    overflow: hidden;
  }

  & .mentions__highlighter,
  & .mentions__input {
    white-space: pre-wrap;
    word-break: break-word;
  }
`

export const SuggestionsPortal = styled.div`
  position: fixed;
  z-index: 9999;
  pointer-events: none;
  
  & > * {
    pointer-events: auto;
  }
`